module.exports = __webpack_public_path__ + "img/4-7subpackage.b0450bee.png";